import type { ContentFileAttributes } from '@/types';

/**
 * Packs a run id into the drive attributes a submit sends.
 *
 * The counterpart of `parsePresetAttributes`: `run:` rides inside the single
 * `category` string for the same reason `slug:` does — the backend drops the
 * generation from Drive when `driveOptions.attributes` carries more than one
 * key (see "Drive attributes workaround" in `docs/reference/api.md`). Appending
 * keeps every field already in the string intact, and the parser matches each
 * one independently.
 *
 * Returns the attributes untouched when there is no run id, so a single-output
 * generation writes exactly what it wrote before.
 */
const withRunAttribute = ({
  attributes,
  runId,
}: {
  attributes?: ContentFileAttributes;
  runId?: string | null;
}): ContentFileAttributes | undefined => {
  if (!runId) return attributes;

  const { category } = attributes ?? {};

  return {
    ...attributes,
    category: category ? `${category}, run:${runId}` : `run:${runId}`,
  };
};

export default withRunAttribute;
